// src/App.jsx
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar.jsx";
import Topbar from "./components/Topbar.jsx";
import Home from "./pages/Home.jsx";

// NEW: Landing
import Landing from "./pages/Landing.jsx";

// GT3 Xperience
import Overview from "./pages/gt3x/Overview.jsx";
import Schedule from "./pages/gt3x/Schedule.jsx";
import Rules from "./pages/gt3x/Rules.jsx";
import Briefing from "./pages/gt3x/Briefing.jsx";
import Startfreigabe from "./pages/gt3x/Startfreigabe.jsx";
import RegisterForm from "./pages/gt3x/Register.jsx";       // „Anmelden“
import RegisterList from "./pages/gt3x/RegisterList.jsx";   // „Anmeldeliste“
import StandingsPro from "./pages/gt3x/StandingsPro.jsx";
import StandingsInt from "./pages/gt3x/StandingsInt.jsx";
import StandingsAm from "./pages/gt3x/StandingsAm.jsx";
import StandingsTeam from "./pages/gt3x/StandingsTeam.jsx";
import StandingsMarken from "./pages/gt3x/StandingsMarken.jsx";
import Penalties from "./pages/gt3x/Penalties.jsx";
import Results from "./pages/gt3x/Results.jsx";   // zeigt /gt3x/ergebnisse
import Reports from "./pages/gt3x/Reports.jsx";
import Protest from "./pages/gt3x/Protest.jsx";
import Streamer from "./pages/gt3x/Streamer.jsx";

// Polls (NEW)
import ManagerPolls from "./pages/manager/admin/ManagerPolls.jsx";
import PollsAdminPage from "./pages/polls/PollsAdminPage";
import PollsRoomPage from "./pages/polls/PollsRoomPage.jsx";
import PollsOverlayPage from "./pages/polls/PollsOverlayPage.jsx";

// DRIVERPROFILE
import Drivers from "./pages/gt3x/Drivers.jsx";
import DriverProfileRoute from "./pages/gt3x/DriverProfileRoute.jsx";
import NameImportPanel from "./pages/manager/admin/NameImportPanel.jsx";

// Login AUTH - Admin Panels
import Login from "./pages/Login.jsx";
import RegisterAccount from "./pages/RegisterAccount.jsx";
import AdminUsers from "./pages/AdminUsers.jsx";
import RequireAdmin from "./auth/RequireAdmin.jsx";
import ManagerAdminHome from "./pages/manager/admin/ManagerAdminHome.jsx";
import ManagerSync from "./pages/manager/admin/ManagerSync.jsx";
import StandingsImportPanel from "./pages/manager/admin/StandingsImportPanel.jsx";
import RekoSyncPanel from "./pages/manager/admin/RekoSyncPanel.jsx";

// Import Archive
import ArchiveSeason1 from "./pages/gt3x/archive/season1/ArchiveSeason1";
import ArchiveSeason1Pro from "./pages/gt3x/archive/season1/ArchiveSeason1Pro.jsx";
import ArchiveSeason1Am from "./pages/gt3x/archive/season1/ArchiveSeason1Am.jsx";
import ArchiveSeason1Team from "./pages/gt3x/archive/season1/ArchiveSeason1Team.jsx";
import ArchiveSeason1Marken from "./pages/gt3x/archive/season1/ArchiveSeason1Marken.jsx";
import ArchiveSeason1Results from "./pages/gt3x/archive/season1/ArchiveSeason1Results";

// Platzhalter weitere Serie
import GTEX from "./pages/gtex/OverviewGTEX.jsx";
import GT4X from "./pages/gt4x/OverviewGT4X.jsx";
import SPECIALX from "./pages/specialx/OverviewSPECIALX.jsx";

import Footer from "./components/Footer.jsx";

export default function App() {
    const location = useLocation();
    const isLanding = location.pathname === "/";

    // Root „/“ soll ein Full-Bleed Layout ohne Sidebar/Topbar sein
    if (isLanding) {
        return (
            <div className="app-landing">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    {/* Fallback → Landing */}
                    <Route path="*" element={<Landing />} />
                </Routes>
            </div>
        );
    }


    // Standardlayout (Liga Manager & alle Unterseiten)
    const closeSidebar = () => {
        document.body.classList.remove("sidebar-open");
    };

    return (
        <div className="app">
            <Sidebar />
            {/* Overlay (nur aktiv, wenn body.sidebar-open) */}
            <div
                className="sidebar-overlay"
                onClick={closeSidebar}
                role="presentation"
            />
            <main className="main">
                <Topbar />
                <div className="content">
                    <Routes location={location}>
                        {/* ALT: Home war hier; jetzt unter /manager */}
                        <Route path="/manager" element={<Home />} />

                        <Route
                            path="/manager/admin"
                            element={
                                <RequireAdmin>
                                    <ManagerAdminHome />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/sync"
                            element={
                                <RequireAdmin>
                                    <ManagerSync />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/name-import"
                            element={
                                <RequireAdmin>
                                    <NameImportPanel />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/polls"
                            element={
                                <RequireAdmin>
                                    <ManagerPolls />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/reko-sync"
                            element={
                                <RequireAdmin>
                                    <RekoSyncPanel />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/users"
                            element={
                                <RequireAdmin>
                                    <AdminUsers />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/import"
                            element={
                                <RequireAdmin>
                                    <StandingsImportPanel />
                                </RequireAdmin>
                            }
                        />

                        {/* GT3 Xperience */}
                        <Route path="/gt3x/overview" element={<Overview />} />
                        <Route path="/gt3x/schedule" element={<Schedule />} />
                        <Route path="/gt3x/rules" element={<Rules />} />
                        <Route path="/gt3x/briefing" element={<Briefing />} />
                        <Route path="/gt3x/startfreigabe" element={<Startfreigabe />} />
                        <Route path="/gt3x/fahrer" element={<Drivers />} />
                        <Route path="/gt3x/fahrer/:driverId" element={<DriverProfileRoute />} />
                        <Route path="/gt3x/streamer" element={<Streamer />} />

                        {/* Anmeldung – direkt */}
                        <Route path="/gt3x/anmeldung/anmelden" element={<RegisterForm />} />
                        <Route path="/gt3x/anmeldung/anmeldeliste" element={<RegisterList />} />

                        {/* Standings */}
                        <Route path="/gt3x/standings/pro" element={<StandingsPro />} />
                        <Route path="/gt3x/standings/int" element={<StandingsInt />} />
                        <Route path="/gt3x/standings/am" element={<StandingsAm />} />
                        <Route path="/gt3x/standings/team" element={<StandingsTeam />} />
                        <Route path="/gt3x/standings/marken" element={<StandingsMarken />} />

                        <Route path="/gt3x/penalties" element={<Penalties />} />
                        <Route path="/gt3x/ergebnisse" element={<Results />} />
                        <Route path="/gt3x/reports" element={<Reports />} />
                        <Route path="/gt3x/protest" element={<Protest />} />

                        <Route path="/gt3x/archiv/season1" element={<ArchiveSeason1 />} />
                        <Route path="/gt3x/archiv/season1/pro" element={<ArchiveSeason1Pro />} />
                        <Route path="/gt3x/archiv/season1/am" element={<ArchiveSeason1Am />} />
                        <Route path="/gt3x/archiv/season1/team" element={<ArchiveSeason1Team />} />
                        <Route path="/gt3x/archiv/season1/marken" element={<ArchiveSeason1Marken />} />
                        <Route path="/gt3x/archiv/season1/results" element={<ArchiveSeason1Results />} />

                        {/* weitere Serie */}
                        <Route path="/gtex" element={<GTEX />} />
                        <Route path="/gt4x" element={<GT4X />} />
                        <Route path="/specialx" element={<SPECIALX />} />

                        {/* Polls */}
                        <Route
                            path="/polls/admin"
                            element={
                                <RequireAdmin>
                                    <PollsAdminPage />
                                </RequireAdmin>
                            }
                        />
                        <Route path="/polls/room" element={<PollsRoomPage />} />
                        <Route path="/polls/overlay" element={<PollsOverlayPage />} />

                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<RegisterAccount />} />

                        <Route path="/admin/users" element={
                            <RequireAdmin>
                                <AdminUsers />
                            </RequireAdmin>
                        } />
                        {/* Fallback → Liga Manager */}
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
                <Footer />
            </main>
        </div>
    );
}